import React from 'react';
import { CommonShow } from '../../shared';

const DxDocumentShow = (props) => <CommonShow {...props} />;
export default DxDocumentShow;
